import { DATE_FORMATS, formatDateByFormat } from '../../utils/dateUtils';
import type { RefreshAge } from '../../utils/dateUtils';
import {
    STALE_STRIP_LABEL_MONTHS_SUFFIX,
    STALE_STRIP_LABEL_PREFIX,
    STALE_STRIP_LABEL_YEARS_SUFFIX,
    STALE_STRIP_TOOLTIP_PREFIX,
    STALE_STRIP_TOOLTIP_SUFFIX,
} from './constants';
import { TabModule } from '../../utils/constants/commonConstants';
import { DATA_FETCH_STATUS } from '../../store/dashboard/constants';
import type { DataFetchingInput, StaleDataStripCopy, StaleDataStripVisibilityInput } from './types';

function buildLabel({ unit, value }: RefreshAge): string {
    const suffix = unit === 'YEARS' ? STALE_STRIP_LABEL_YEARS_SUFFIX : STALE_STRIP_LABEL_MONTHS_SUFFIX;
    return `${STALE_STRIP_LABEL_PREFIX}${value}${suffix}`;
}

export function buildStaleDataStripCopy(staleness: RefreshAge, timestamp: number): StaleDataStripCopy {
    const label = buildLabel(staleness);
    const tooltipText = `${STALE_STRIP_TOOLTIP_PREFIX}${formatDateByFormat(
        timestamp,
        DATE_FORMATS.DATE_FORMAT_D_MMM_YYYY,
    )}${STALE_STRIP_TOOLTIP_SUFFIX}`;
    return { label, tooltipText, ariaLabel: `${label}. ${tooltipText}` };
}

export function hasPrimaryModuleProcessing(primaryDataStatusMap: Map<string, string>): boolean {
    return Array.from(primaryDataStatusMap.entries()).some(
        ([module, status]) => module !== TabModule.BANKING_AND_FINANCIALS && status === DATA_FETCH_STATUS.PROCESSING,
    );
}

export function isDataFetching({ modulePollingList, extendedPollingModules, primaryModuleProcessing }: DataFetchingInput): boolean {
    return modulePollingList.length > 0 || extendedPollingModules.length > 0 || primaryModuleProcessing;
}

export function isStaleDataStripVisible({ copy, isFetchingData, shouldDisableUnlock }: StaleDataStripVisibilityInput): boolean {
    return !!copy && !isFetchingData && !shouldDisableUnlock;
}
